<template>
  <v-expansion-panel class="border-expansion">
    <v-expansion-panel-header
      class="white--text content_background"
      expand-icon="mdi-menu-down"
    >
      <v-row class="ma-0">
        <v-col cols="6" class="pa-0">
          <span class="primary--text">{{
            isEditing ? tripObject.reference_number : "New Trip"
          }}</span>
        </v-col>
        <v-col cols="6" class="pa-0 d-flex justify-end align-center">
          <v-icon
            color="primary"
            @click="$emit('removeTrip', tripIndex)"
            v-if="!isEditing"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>
      <template v-slot:actions>
        <v-icon color="white"> mdi-chevron-down </v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content
      class="expansion-container-margin rounded rounded-t-0 pa-0"
      color="white"
    >
      <v-row class="ma-0 pa-2">
        <v-col
          cols="12"
          class="pa-2"
          v-if="tripErrors && tripErrors.non_field_errors"
        >
          <v-alert dense type="error" class="ma-0">
            <v-list
              class="pa-0"
              dense
              style="background: inherit !important"
              v-for="(error, i) in tripErrors.non_field_errors"
              :key="i"
            >
              <v-list-item dense style="min-height: 20px !important">
                <span>{{ i }} .</span><span>{{ error }}</span>
                <v-spacer></v-spacer>
                <v-btn
                  color="white"
                  icon
                  @click="$emit('removeError', tripIndex, 'non_field_errors')"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-alert>
        </v-col>

        <v-col
          cols="12"
          v-if="
            tripObject['tiaData'] &&
            Object.keys(tripObject['tiaData']).length > 0
          "
        >
          <v-card height="100%" outlined>
            <v-card-title class="pa-2"> Trip statistics </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-2">
              <v-row
                class="trip-expansion-body"
                v-if="
                  tripObject &&
                  tripObject['tiaData'] &&
                  tripObject['tiaData'].statistics
                "
              >
                <v-col
                  cols="6"
                  md="3"
                  lg="2"
                  v-for="(value, key, index) of tripObject['tiaData']
                    .statistics"
                  :key="index"
                >
                  <v-card flat>
                    <v-card-title class="pa-1 text-capitalize">
                      <h6>{{ key.replace(/_/g, " ") }}</h6>
                    </v-card-title>
                    <v-card-text class="pa-1">
                      <span v-if="value">
                        {{ value }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          v-if="!tripObject['tiaData'] && Object.keys(statistic).length"
        >
          <v-card height="100%" outlined>
            <v-card-title class="pa-2"> Trip statistics </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-2">
              <v-row class="trip-expansion-body">
                <v-col
                  cols="6"
                  md="3"
                  lg="2"
                  v-for="(value, key, index) of statistic"
                  :key="index"
                >
                  <v-card flat>
                    <v-card-title class="pa-1 text-capitalize">
                      <h6>{{ key.replace(/_/g, " ") }}</h6>
                    </v-card-title>
                    <v-card-text class="pa-1">
                      <span v-if="value">
                        {{ value }}
                      </span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          v-if="
            tripObject['tiaData'] &&
            tripObject['tiaData'].recommended_assets_statistic
          "
          class="d-flex align-items space-between align-center"
        >
          <v-card outlined color="pa-2" width="100%">
            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="info" class="mr-2"
                  >mdi-information</v-icon
                >
              </template>
              <span>Click on the vehicle to assign it to this trip</span>
            </v-tooltip>

            <span class="text-capitalize primary--text pr-4">
              Recommended Vehicles :
            </span>
            <v-tooltip
              top
              v-for="(obj, index) in tripObject['tiaData']
                .recommended_assets_statistic"
              :key="index"
              max-width="16vw"
            >
              <template #activator="{ on, attrs }">
                <v-chip
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="assignRecommendedVehicle(obj)"
                >
                  <v-icon color="primary" class="mr-2">mdi-truck</v-icon>
                  {{ obj.vehicle.vehicle_number }}
                </v-chip>
              </template>
              <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-space-between">
                  <span>Utilization :</span>
                  <span>
                    {{ obj.asset_statistics.vehicle_utilized }}
                  </span>
                </v-col>
                <v-col
                  cols="12"
                  class="d-flex justify-space-between"
                  v-if="obj.driver"
                >
                  <span>Assigned Driver :</span>
                  <span> {{ obj.driver.full_name }}</span>
                </v-col>
              </v-row>
            </v-tooltip>
          </v-card>
        </v-col>

        <v-col cols="3" class="pa-2">
          <InputField
            type="text"
            v-model="tripObject.reference_number"
            label="Reference Number"
            hide-details="auto"
            :required="true"
            :error-messages="
              tripErrors && tripErrors.reference_number
                ? tripErrors.reference_number
                : null
            "
            @input="$emit('removeError', tripIndex, 'reference_number')"
          />
        </v-col>
        <v-col cols="3" class="pa-2">
          <SelectField
            v-if="
              !tripObject['vehicle_info'] || tripObject.status == 'unallocated'
            "
            :label="`Select ${fleetModule.vehicle}${
              !isEditing || isDriverAndVehicleRequired ? '*' : ''
            }`"
            :itemsList="vehicleList"
            :is-clearable="true"
            itemText="vehicle_number"
            itemValue="id"
            @change="getCheckDriver"
            v-model="tripObject.vehicle"
            :return-object="true"
            :required="!isEditing || isDriverAndVehicleRequired"
            :error-messages="
              tripErrors && tripErrors.vehicle ? tripErrors.vehicle : null
            "
            :rules="
              !isEditing || isDriverAndVehicleRequired ? isVehicleRequired : []
            "
            @input="$emit('removeError', tripIndex, 'vehicle')"
          />
          <div v-else>
            <v-chip
              class="ma-2"
              color="primary"
              v-if="tripObject['vehicle_info']"
            >
              <v-icon class="mr-2">mdi-truck</v-icon>
              {{ tripObject["vehicle_info"]["vehicle_number"] }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="3" class="pa-2">
          <SelectField
            v-if="
              !tripObject['driver_info'] || tripObject.status == 'unallocated'
            "
            :label="`Select ${fleetModule.driver}${
              !isEditing || isDriverAndVehicleRequired ? '*' : ''
            }`"
            :itemsList="driverList"
            :is-clearable="true"
            itemText="full_name"
            itemValue="id"
            :required="!isEditing || isDriverAndVehicleRequired"
            @change="getCheckVehicle"
            :return-object="true"
            v-model="tripObject.driver"
            :error-messages="
              tripErrors && tripErrors.driver ? tripErrors.driver : null
            "
            @input="$emit('removeError', tripIndex, 'driver')"
            :rules="
              !isEditing || isDriverAndVehicleRequired ? isDriverRequired : []
            "
          />
          <div v-else>
            <v-chip
              class="ma-2"
              color="primary"
              v-if="tripObject['driver_info']"
            >
              <v-icon class="mr-2">mdi-account-tie-hat</v-icon>
              {{ tripObject["driver_info"]["full_name"] }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="3" class="pa-2">
          <SelectField
            :itemsList="warehouseList"
            item-text="name"
            item-value="id"
            :required="isRoundTrip"
            :error-messages="
              tripErrors && tripErrors.start_location_warehouse
                ? tripErrors.start_location_warehouse
                : null
            "
            :label="
              !isRoundTrip
                ? 'Select Warehouse as Starting Address'
                : 'Select Warehouse as Starting Address*'
            "
            :rules="
              isRoundTrip
                ? [
                    (val) =>
                      !!val ||
                      'Select Warehouse as Starting Location is required',
                  ]
                : []
            "
            v-model="tripObject.start_location_warehouse"
          />
        </v-col>

        <v-col
          cols="12"
          @dragenter.stop.prevent
          @dragover.stop.prevent
          @drop.stop.prevent="$emit('dropOrder', tripIndex)"
          class="pa-2 drop-container-expansion"
        >
          <div
            v-if="tripObject.trip_orders && !tripObject.trip_orders.length"
            class="d-flex align-center justify-center grey lighten-4 fill-height"
          >
            <span class="grey--text">Drop {{ orderModule.order }}'s here</span>
          </div>
          <v-data-table
            v-else
            :headers="tableHeaders"
            :items="tripObject.trip_orders"
            :items-per-page="-1"
            disable-pagination
            hide-default-footer
            class="trip-expendable-table"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="(tripOrder, tripOrderIndex) in items"
                  :key="tripOrderIndex"
                  draggable
                  @dragenter.stop.prevent
                  @dragover.stop.prevent
                  @drag="$emit('orderDragStart', tripOrder.id, tripIndex)"
                  @drop.stop.prevent="
                    $emit('dropOrder', tripIndex, tripOrderIndex)
                  "
                >
                  <td v-if="hasError()">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="red"
                          v-if="hasOrderError(tripOrderIndex)"
                          v-bind="attrs"
                          v-on="on"
                          >mdi-alert</v-icon
                        >
                      </template>
                      <span>{{ getError(tripOrderIndex) }}</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <span class="text-truncate">
                      {{ tripOrder.reference_number }}
                    </span>
                    <CopyToClipboard
                      :textTobeCopied="tripOrder.reference_number"
                      iconClass="ml-2"
                    />
                  </td>
                  <td>{{ tripOrder.customer_name }}</td>
                  <td v-if="tripType == 'sales'">
                    {{ tripOrder.customer_code }}
                  </td>
                  <td v-if="tripType == 'sales'">
                    {{ tripOrder.location_id }}
                  </td>
                  <td>{{ tripOrder.contact_number }}</td>
                  <td>{{ tripOrder.order_type }}</td>
                  <td>{{ tripOrder.address }}</td>
                  <td>{{ tripOrder.customer_availability_window }}</td>
                  <td>{{ tripOrder.planned_processing_time }}</td>
                  <td v-if="$helper.isCompanyHasItems()">
                    {{ tripOrder.total_items }}
                  </td>
                  <td>{{ tripOrder.volume }}</td>
                  <td>{{ tripOrder.weight }}</td>
                  <td>
                    <v-icon
                      @click="
                        $emit('removeOrderFromTrip', tripOrder.id, tripIndex)
                      "
                    >
                      mdi-close
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
        <v-col
          v-if="tripObject.trip_orders.length > 2 && !isEditing"
          class="d-flex justify-space-between"
        >
          <span class="font-weight-bold"> Recommendation Settings :</span>
          <SwitchField
            right
            v-model="recommendation_settings.zone_validation"
            label="Zone Validation"
          />
          <SwitchField
            class="mx-2"
            right
            v-model="recommendation_settings.tag_validation"
            label="Tag Validation"
          />
          <SwitchField
            right
            v-model="recommendation_settings.driver_shift_validation"
            label="Driver Shift Validation"
          />
        </v-col>
        <v-col cols="4" class="d-flex justify-end">
          <PrimaryButton
            v-if="tripObject.tiaData"
            small
            btnClass="mr-2"
            @click="$emit('viewTripOnMap')"
            name="View on Map"
            icon="mdi-map-marker"
            iconSize="x-large"
          >
          </PrimaryButton>
          <PrimaryButton
            v-if="tripObject.trip_orders.length > 2 && !isEditing"
            btnClass=""
            small
            @click="
              $emit('getTiaRecoomendations', { ...recommendation_settings })
            "
            name="Tia Recommendation"
          >
          </PrimaryButton>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import CopyToClipboard from "@/components/GeneralComponents/CopyToClipboard.vue";
import {
  fleetModule,
  orderModule,
  configurationModule,
} from "@/utils/moduleMapping";
import { tripReferenceValidation, loadGoogleInstance } from "@/utils/functions";

export default {
  components: { CopyToClipboard },
  emits: [
    "removeOrderFromTrip",
    "orderDragStart",
    "dropOrder",
    "removeTrip",
    "removeError",
    "getTiaRecoomendations",
    "viewTripOnMap",
  ],
  props: {
    value: {
      required: true,
    },
    tripType: {
      default: "sales",
    },
    isRoundTrip: {
      type: Boolean,
      default: false,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    tripIndex: {
      required: true,
    },
    tripErrors: {
      required: true,
    },
    driverList: {
      type: Array,
      default: () => [],
    },
    vehicleList: {
      type: Array,
      default: () => [],
    },
    warehouseList: {
      type: Array,
      default: () => [],
    },
    isChartVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tripObject: {
      get() {
        if (this.value?.trip_orders.length) {
          this.calculateTripOrderStatistics(this.value?.trip_orders);
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isDriverAndVehicleRequired() {
      if (
        (this.tripObject && this.tripObject.driver) ||
        this.tripObject.vehicle
      ) {
        return true;
      } else {
        false;
      }
    },

    isVehicleRequired() {
      return [(val) => !!val || `${this.fleetModule.vehicle} is required`];
    },
    isDriverRequired() {
      return [(val) => !!val || `${this.fleetModule.driver} is required`];
    },
    tableHeaders() {
      if (this.tripType == "sales") {
        this.orderHeaders.splice(
          2,
          0,
          ...[
            { text: "Customer Code", value: "customer_code", sortable: false },
            { text: "Location ID", value: "location_id", sortable: false },
          ]
        );
      }

      if (this.$helper.isCompanyHasItems()) {
        this.orderHeaders.splice(9, 0, {
          text: "Total Items",
          value: "total_items",
          sortable: false,
        });
      }
      return [
        ...(this.hasError()
          ? [
              {
                text: "#",
                value: "id",
                sortable: false,
              },
            ]
          : []),
        ...this.orderHeaders,
      ];
    },
  },
  data() {
    return {
      recommendation_settings: {
        zone_validation: false,
        tag_validation: false,
        driver_shift_validation: false,
      },
      tripReferenceValidation,
      fleetModule,
      orderModule,
      configurationModule,

      orderHeaders: [
        {
          text: "Order Reference Number",
          value: "reference_number",
          sortable: false,
        },
        { text: "Customer Name", value: "customer_name", sortable: false },

        { text: "Contact Number", value: "contact_number", sortable: false },
        { text: "Order type", value: "order_type", sortable: false },
        { text: "Address", value: "address", sortable: false, width: 200 },
        {
          text: "Time Window",
          value: "customer_availability_window",
          sortable: false,
          width: 140,
        },
        {
          text: "Planned Processing time",
          value: "planned_processing_time",
          sortable: false,
        },
        {
          text: "Volume",
          value: "volume",
          sortable: false,
          width: 125,
        },
        {
          text: "Weight",
          value: "weight",
          sortable: false,
          width: 105,
        },
        { text: "Actions", value: "id", sortable: false },
      ],
      paymentOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var currentValue = dataset.data[tooltipItem.index];
              return currentValue + " %";
            },
          },
        },
        legend: {
          boxWidth: 20,
          display: true,
          textAlign: "start",
          position: "bottom",
        },
      },

      selectedVehicle: null,

      statistic: {},
    };
  },

  methods: {
    calculateTripOrderStatistics(tripOrders) {
      const totalOrderWeight = tripOrders
        .reduce((total, order) => total + parseFloat(order.weight), 0)
        .toFixed(2);
      const totalOrderVolume = tripOrders
        .reduce((total, order) => total + parseFloat(order.volume), 0)
        .toFixed(4);
      const totalOrder = tripOrders.length;
      this.statistic = {
        total_volume: `${totalOrderVolume} CBM`,
        total_weight: `${totalOrderWeight} KG`,
        total_order: totalOrder,
      };
    },

    getCheckDriver(vehicleObj) {
      // if (vehicleObj && vehicleObj.assigned_driver_id) {
      //   this.tripObject.driver = parseInt(vehicleObj.assigned_driver_id);
      // } else {
      //   this.tripObject.driver = null;
      // }
      if (vehicleObj && vehicleObj.id) {
        this.tripObject.vehicle = parseInt(vehicleObj.id);
      }
    },
    getCheckVehicle(driverObj) {
      if (driverObj && driverObj.vehicle_assigned_id) {
        this.tripObject.vehicle = parseInt(driverObj.vehicle_assigned_id);
      } else {
        // this.tripObject.vehicle = null;
      }
      if (driverObj && driverObj.id) {
        this.tripObject.driver = parseInt(driverObj.id);
      }
    },
    hasError() {
      return (
        this.tripErrors &&
        this.tripErrors.trip_orders &&
        this.tripErrors.trip_orders.some(
          (error) => error && Object.keys(error).length
        )
      );
    },
    hasOrderError(orderIndex) {
      return (
        this.hasError() &&
        this.tripErrors.trip_orders[orderIndex] &&
        this.tripErrors.trip_orders[orderIndex].non_field_errors
      );
    },
    getError(orderIndex) {
      let error = null;
      if (this.hasOrderError(orderIndex)) {
        error = this.tripErrors.trip_orders[orderIndex].non_field_errors.join();
      }
      return error;
    },
    assignRecommendedVehicle(obj) {
      let tripObj = { ...this.tripObject };
      tripObj.vehicle = obj.vehicle.id;
      if (obj.driver) {
        tripObj.driver = obj.driver.id;
      }
      this.tripObject = tripObj;
    },
  },
};
</script>

<style>
.border-expansion {
  border: 1px solid var(--v-primary-base);
}
.v-expansion-panel-content__wrap {
  padding: 0px;
}
.expansion-container-margin {
  margin: 2px;
}

.drop-container-expansion {
  min-height: 150px;
}
.trip-expendable-table .v-data-table__wrapper {
  overflow-y: auto !important;
  width: calc(100vw - 470px) !important;
}
.trip-expendable-table table th {
  white-space: nowrap;
}
.trip-expendable-table .v-data-table {
  overflow-y: auto !important;
}
</style>
